export default {"src":"/_next/static/media/360-spin-overlay.220435f7.svg","height":60,"width":60};